import { MODEL_ACTIONS } from "~/actions/model_actions"
import invalidateLoadedModels from "./helpers/invalidateLoadedModels";
import { getLoadedModels } from "~/stateGetter";

import filter from "lodash/filter";
import map from "lodash/map";

export const reduceSubviews = (state, action) => {
    switch(action.type) {
        case MODEL_ACTIONS.INVALIDATE_SUBVIEWS: return (
            invalidateLoadedModels(state, {
                include: map(filter(getLoadedModels(state), { parentModelId: action.modelId }), 'modelId')
            })
        );
    }

    return state;
}